import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const AuthSchema = z
    .object({
        client_id: z.string().min(10),
        client_secret: z.string().min(10),
        grant_type: z.string().optional(),
    })
    .strict();

export class CreateAuthDto extends FromSchema(AuthSchema) {
    client_id: string;
    client_secret: string;
    grant_type: string;
}
